export function formatAttachments (attachments) {
  return attachments.map(attachment => {
    return {
      id: attachment.id,
      url: attachment.url,
      type: attachment.type,
      description: attachment.description
    }
  })
}
